<div
  class="flex flex-col gap-9 mt-8"
  *ngIf="detailDeploySystem">
  <div class="flex justify-between items-center">
    <app-back-button />

    <app-buttons
      *ngIf="canCurrentUserAccessReview()"
      [label]="reviewButtonLabel"
      [classes]="'text-primary-base'"
      (click)="goToDeployReview()" />
    <app-buttons
      *ngIf="canCurrentUserCorrect()"
      [label]="'Subsanar despliegue de sistema'"
      [classes]="'text-primary-base'"
      (click)="goToCorrection()" />
  </div>

  <div class="flex justify-between items-center">
    <div class="text-[30px] font-bold">
      {{ detailDeploySystem.systemName || '-' }}
    </div>
  </div>

  <div class="flex items-center gap-3">
    <div
      class="w-4 h-4"
      [ngClass]="colorBox()"></div>
    <div class="text-md font-semibold">{{ stateTextFormat() }}</div>
    <span class="text-md text-neutral-dark">
      Creado el {{ detailDeploySystem.creationDate || '' | spanishDate }}, por
      {{ detailDeploySystem.creationUser || '-' }}
    </span>
  </div>

  <div class="flex flex-col gap-1">
    <span
      class="text-md font-semibold"
      [ngClass]="detailDeploySystem?.systemClassification | riskLevelClass">
      Riesgo: {{ getRiskLevelLabel(detailDeploySystem?.systemClassification) }}
    </span>

    <app-review-states
      *ngIf="detailDeploySystem.state !== 'REJECTED'"
      [context]="'deploy-system'"
      [stateGroups]="stateGroups"
      [activeStage]="activeStage"
      [projectState]="detailDeploySystem.state ?? undefined"
      [showReviewButton]="canCurrentUserReview()"
      [reviewButtonLabel]="reviewStatesButtonLabel"
      [onReview]="goToDeployReview.bind(this)"></app-review-states>

    <div class="flex flex-col gap-6 mt-6">
      <span class="text-[18px] font-bold">Datos funcionales</span>

      <div class="grid grid-cols-2 gap-4">
        <div class="flex flex-col">
          <span class="text-[14px] text-neutral-dark">Proyecto asociado</span>
          <span class="text-md font-normal">
            {{ detailDeploySystem.projectAssociated || '-' }}
          </span>
        </div>

        <div class="flex flex-col">
          <span class="text-[14px] text-neutral-dark">Tipo de sistema</span>
          <span class="text-md font-normal">
            {{ getSystemTypeLabel(detailDeploySystem.systemType) }}
          </span>
        </div>
      </div>
      <div class="flex flex-col gap-2">
        <span class="text-sm text-neutral-dark">Fecha estimada de despliegue del sistema</span>
        <span class="text-md font-normal">
          {{ detailDeploySystem.estimatedDeployDate || '-' }}
        </span>
      </div>
      <div class="flex flex-col gap-2">
        <span class="text-[14px] text-neutral-dark">Funciones o tareas a las que da soporte el sistema</span>

        <div class="flex flex-wrap gap-4">
          @for (func of detailDeploySystem.functions || []; track func) {
            <app-pill
              [value]="getFunctionLabel(func)"
              [classe]="'c-pill--primary'" />
          }
        </div>
      </div>

      <div class="flex flex-col gap-2">
        <span class="text-sm text-neutral-dark">Descripción del funcionamiento del sistema</span>

        <span class="text-md font-normal whitespace-pre-line">
          {{ detailDeploySystem.description || '-' }}
        </span>
      </div>
    </div>
    <div class="flex flex-col gap-8 mt-8">
      <app-system-deploy-ria-compliance [riaData]="detailDeploySystem"></app-system-deploy-ria-compliance>
      <app-system-deploy-technical-issues
        [technicalIssuesData]="detailDeploySystem"></app-system-deploy-technical-issues>
      <app-system-deploy-iso-compliance [isoData]="detailDeploySystem"></app-system-deploy-iso-compliance>
      <app-system-deploy-hap-compliance [hapData]="detailDeploySystem"></app-system-deploy-hap-compliance>
      <app-system-deploy-economic-data [economicData]="detailDeploySystem"></app-system-deploy-economic-data>
      <app-system-deploy-impact-evaluation [impactData]="detailDeploySystem"></app-system-deploy-impact-evaluation>
      <app-system-deploy-risk-management [riskData]="detailDeploySystem"></app-system-deploy-risk-management>
    </div>
  </div>
  <div class="flex flex-col gap-6">
    <desy-collapsible>
      <span class="text-xl font-bold">Proyectos relacionados</span>
      <desy-content>
        <div class="flex flex-col flex-1">
          @for (card of detailDeploySystem?.infoCard || []; track card.id) {
            <app-project-card
              [projectName]="card.projectName || '-'"
              [state]="card.state || '-'"
              [buttons]="card.buttons || []"
              [creationUser]="card.creationUser || '-'"
              [creationDate]="card.date ?? projectCardFallbackDate"
              [infoCard]="card.infoCard ?? []"
              [description]="card.description || '-'" />
          }
        </div>
      </desy-content>
    </desy-collapsible>
  </div>
</div>
